module.exports = __webpack_public_path__ + "static/Incident_1-365c794fc4349a1f01905356744bc45a.png";